export const size = {
    A: 2,
    B: 4,
    C: 8,
    D: 11,
    E: 13,
    F: 15,
    G: 17,
    H: 19,
    I: 21,
    J: 23,
    K: 28,
    L: 34,
    M: 45,
    N: 62,
    O: 72,
    P: 89
};
//# sourceMappingURL=spacing.js.map